<template>
  <button
    class="btn"
    :class="mode === 'outline' ? 'outline' : ''"
    @mouseenter="handleButtonHover(true)"
    @mouseleave="handleButtonHover(false)"
    @click="handleButtonClick"
    ref="btn"
    :style="{
      backgroundColor: disabled
        ? '#EFEFEF'
        : mode === 'outline'
        ? 'transparent'
        : backgroundColor,
      color: mode === 'outline' ? backgroundColor : '#fff',
      borderColor: mode === 'ouline' ? 'transparent' : backgroundColor
    }"
    :type="type"
    :disabled="disabled"
  >
    <slot />
    <span
      v-if="label"
      v-html="label"
      :style="{
        color: disabled ? '#CCCCCC' : spanCustomStyles
      }"
      ref="contentLabel"
    ></span>
  </button>
</template>

<script>
export default {
  name: "ActionButton",
  data() {
    return {
      backgroundColor: this.theme.primary,
      isHovered: false
    };
  },
  props: {
    label: {
      type: String,
      default: "Submit"
    },
    theme: {
      type: Object,
      default: () => ({
        primary: "#51B67E",
        secondary: "#E1FAF4",
        event: "#0BAC81",
        delete: "#dc3545"
      })
    },
    type: {
      type: String,
      default: "button"
    },
    disabled: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: "bg"
    },
    color: {
      type: String,
      default: ""
    }
  },
  computed: {
    spanCustomStyles() {
      return this.mode === "outline"
        ? this.color || this.backgroundColor
        : "#fff";
    }
  },
  watch: {
    theme() {
      this.backgroundColor = this.theme.primary;
    },
    disabled() {
      if (!this.$refs.contentLabel) return;
      this.$refs.contentLabel.style.color = this.color ? this.color : "#fff";
    }
  },
  methods: {
    handleButtonHover(params) {
      if (this.mode === "outline") {
        if (params) {
          this.$refs.btn.style.backgroundColor = this.color
            ? "transparent"
            : this.theme.primary;
          this.$refs.btn.style.color = this.color ? this.theme.primary : "#fff";
          this.backgroundColor = this.theme.primary;

          if (this.label) {
            this.$refs.contentLabel.style.color = this.color
              ? this.theme.primary
              : "#fff";
          }
        } else {
          this.$refs.btn.style.backgroundColor = "transparent";
          this.$refs.btn.style.color = this.theme.primary;
          this.backgroundColor = this.theme.primary;

          if (this.label) {
            this.$refs.contentLabel.style.color =
              this.color || this.theme.primary;
          }
        }
      } else {
        params === true
          ? (this.backgroundColor = this.theme.event)
          : (this.backgroundColor = this.theme.primary);
      }
    },
    handleButtonClick() {
      this.$emit("customEvent");
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  border-radius: 5px;
  color: #fff;
  display: block;
  font-size: $font-size-sm;
  line-height: 16px;
  margin-top: 30px;
  padding: 8px 14px;
  transition: all 0.3s ease;
  width: 100%;
  span {
    color: #fff;
    font-family: "Gotham", sans-serif;
    margin-left: 0;
  }
  &:disabled {
    background-color: "#EFEFEF";
    border: none;
  }
}
</style>
